import { FieldBase } from "./field-base.model";

export class InputTextField extends FieldBase<string> {
  controlType = "text";
}
